import axios from "axios";

export const ToolApi = axios.create({
    baseURL: "/api/"
})